import {Routes} from '@angular/router';
import {LoginFailedComponent} from "./auth/pages/login-failed/login-failed.component";
import {MsalGuard} from "@azure/msal-angular";

export const routes: Routes = [
    {
        path: 'login-failed',
        component: LoginFailedComponent,
    },
    {
        path: '',
        redirectTo: 'admin/dashboard',
        pathMatch: 'full',
    },
    {
        path: 'admin',
        canActivate: [MsalGuard],
        loadChildren: () => import('./admin/admin-routing.module').then(m => m.AdminRoutingModule),
    }
];
